import styles from '../../sass/components/Card.module.scss'
import {useEffect} from "react";
import {ButtonBorderless} from "@/Components/Buttons/ButtonBorderless";

/**
 * The card component comes in two sizes (lg|sm) that controls the amount of padding on the card.
 * The action object controls a clickable action in the upper right of the card.
 * If an action is passed, an icon is optional, but an onClick is required.
 */
export function Card({
                         title,
                         size = 'lg',
                         action = {
                             icon: null,
                             text: null,
                             onClick: null
                         },
                         children,
                         className,
                         dataTestid
                     }) {
    useEffect(() => {
        if (action.text === undefined || action.text === null) {
            return;
        }

        if (typeof action.onClick !== 'function') {
            console.error(
                `Your card component with a title of '${title}' and an action text of '${action.text}' needs to define an action.onClick function.`
            )
        }
    }, [])

    return (<div data-testid={'card-div-'+dataTestid} className={className ? styles.card + ' ' + className : styles.card}>
            <span className={styles.header}>
                <h3 className={styles.title}>{title}</h3>
                {action.text && (
                    <ButtonBorderless
                        size="sm"
                        disabled={false}
                        iconLeft={action.icon}
                        onClick={action.onClick}
                        className={styles.action}
                    >{action.text}</ButtonBorderless>
                )}
            </span>
        <div className={`${styles.content} ${size === 'lg' ? styles.lg : styles.sm}`}>
            {children}
        </div>
    </div>)
}
